import Information from './Information'

const DeviceLiquidation = {
    Information,
}

export default DeviceLiquidation
